import { Directive, ElementRef, inject, OnDestroy } from '@angular/core';
import { fromEvent, merge, of, Subscription, take, timer } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Directive({
    selector: '[app-ios-contextmenu]',
})
export class IosContextMenuDirective implements OnDestroy {
    private elementRef = inject(ElementRef);

    private readonly eventSubscribe?: Subscription;
    private threshold = 500;

    constructor() {
        const isIOS = () => {
            if (/iPad|iPhone|iPod/.test(navigator.platform)) {
                return true;
            } else {
                return (
                    navigator.maxTouchPoints &&
                    navigator.maxTouchPoints > 2 &&
                    /MacIntel/.test(navigator.platform)
                );
            }
        };

        const isIpadOS = () => {
            return (
                navigator.maxTouchPoints &&
                navigator.maxTouchPoints > 2 &&
                /MacIntel/.test(navigator.platform)
            );
        };

        if (!isIOS() && !isIpadOS()) {
            return;
        }

        const mousedown = fromEvent<MouseEvent>(this.elementRef.nativeElement, 'mousedown').pipe(
            filter((event) => event.button === 0), // Only allow left button (Primary button)
            map(() => true), // turn on threshold counter
        );
        const touchstart = fromEvent(this.elementRef.nativeElement, 'touchstart').pipe(map(() => true));
        const touchMove = fromEvent(this.elementRef.nativeElement, 'touchmove').pipe(map(() => false));
        const touchEnd = fromEvent(this.elementRef.nativeElement, 'touchend').pipe(map(() => false));
        const mouseup = fromEvent<MouseEvent>(window, 'mouseup').pipe(
            filter((event) => event.button === 0), // Only allow left button (Primary button)
            map(() => false), // reset threshold counter
        );
        this.eventSubscribe = merge(mousedown, mouseup, touchstart, touchMove, touchEnd)
            .pipe(
                switchMap((state) => (state ? timer(this.threshold, 100).pipe(take(2)) : of(null))),
                filter((value) => !!value),
            )
            .subscribe(() => {
                this.elementRef.nativeElement.dispatchEvent(
                    new Event('contextmenu'),
                    new MouseEvent('contextmenu'),
                );
            });
    }

    ngOnDestroy(): void {
        if (this.eventSubscribe) {
            this.eventSubscribe.unsubscribe();
        }
    }
}
